// extracted by mini-css-extract-plugin
export default {"group":"BOMItemsGroup__group--zahQK","title":"BOMItemsGroup__title--SGXkt"};